import { PRINT_MINIMUMS_BY_SKU } from "../../../helpers/constants";
import { Input } from "../../fields";
import { NoTemplate } from "./NoTemplate";
import { usePrintTypeValues } from "./helpers";

export const PaperTemplateSelect = ({ type, ...props }) => {
  console.log("❗️ - PaperTemplateSelect - props:", props);
  const { skus, required } = usePrintTypeValues(type);
  if (!skus.length) return <NoTemplate />;
  return skus.map((sku) => {
    const minimum = PRINT_MINIMUMS_BY_SKU[sku];
    return (
      <Input
        key={sku}
        sku={sku}
        type="number"
        placeholder="Quantity"
        required={required}
        minimum={minimum}
        {...props}
      />
    );
  });
};
